// extracted by mini-css-extract-plugin
module.exports = {"warningButtons":"style_warningButtons__3LHCr","newPlatforms":"style_newPlatforms__2o15R"};